$(document).ready(function() {
    const $slideshow = $('.images-with-text .images');

    $slideshow.slick({
        dots: false,
        arrows: false,
        slidesToShow: 2,
        slidesToScroll: 2,
        speed: 600,
        autoplay: true,
        responsive: [
            {
                breakpoint: 769,
                settings: {
                    dots: true,
                    slidesToShow: 1,
                    slidesToScroll: 1,
                }
            }
        ]
    });
});
